import React from 'react';
import { Checkbox } from 'rebass';

import config from 'frontend/config';

const RaidbotsCheckbox = ({ ...props }) => (
  <Checkbox
    backgroundColor={config.colors.black}
    {...props}
  />
);

export default RaidbotsCheckbox;
